import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';

import { has as _has, isFunction as _isFunction } from 'lodash';
import memoize from 'memoize-one';
import PropTypes from 'prop-types';

import Shimmer from '@vfgroup-oneplatform/foundation/Components/Shimmer';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import VFTouchableInScroll from '@vfgroup-oneplatform/foundation/Components/VFTouchableInScroll';

import FrameworkTestKeys from '../../../../FrameworkTestKeys';
import DashboardErrorCard from '../../DashboardErrorCard/DashboardErrorCard';

import styles from './DiscoverCard.styles';

class DiscoverCard extends Component {
  constructor(props) {
    super(props);
    this.card = React.createRef();
    this.parallaxRef = React.createRef();
  }
  onScroll = scrollY => {
    if (this.parallaxRef && _isFunction(this.parallaxRef.onScroll)) {
      this.parallaxRef.onScroll(scrollY);
    }
  };
  getProperCardStyle = (type, style, showAddIcon) => {
    const localStyle = styles[type] ?? styles.discover;
    return StyleSheet.flatten([localStyle, style]);
  };

  getProperCardStyleMemoized = memoize(this.getProperCardStyle);
  init = () => {
    if (_has(this.props, 'componentName') && this.card && _isFunction(this.card.init)) {
      this.card.init();
    }
  };
  dispose = () => {
    if (_has(this.props, 'componentName') && this.card && _isFunction(this.card.dispose)) {
      this.card.dispose();
    }
  };
  handleOnPressCard = () => {
    const clonedProps = { ...this.props };
    delete clonedProps.children;
    delete clonedProps.accessibilityLabel;
    delete clonedProps.type;
    delete clonedProps.onPressCard;
    delete clonedProps.onPressCard;
    const { componentName, ...additionalInfo } = clonedProps;
    // this.props?.onPressCard(componentName, additionalInfo);
  };

  render() {
    const clonedProps = { ...this.props };
    const { loadingConfig, shimmerPlaceholderConfig, isLoading, theme, discoverLoadingError } =
      this.props;
    delete clonedProps.componentName;
    const { type, showAddIcon, style, ...props } = clonedProps;
    const cardStyle = this.getProperCardStyleMemoized(type, style, showAddIcon);
    const ClonedDiscoverCard = React.cloneElement(this.props.children, {
      ref: card => {
        this.card = card;
      },
      setParallaxRef: parallaxRef => (this.parallaxRef = parallaxRef),
    });
    return (
      <VFTouchableInScroll
        onPress={this.handleOnPressCard}
        accessible={false}
        testID={FrameworkTestKeys.dashboardDiscoverCardVFT}
      >
        {isLoading ? (
          <View
            style={cardStyle}
            {...props}
            testID={FrameworkTestKeys.DiscoverCardContainerIsLoading}
          >
            <View
              style={styles.shimmerContainer(theme)}
              testID={FrameworkTestKeys.dashboardDiscoverCardLoadingView}
            >
              <Shimmer config={loadingConfig} shimmerPlaceholderConfig={shimmerPlaceholderConfig} />
            </View>
          </View>
        ) : discoverLoadingError ? (
          <View
            style={[cardStyle, styles.errorCardStyle]}
            {...props}
            testID={FrameworkTestKeys.DiscoverCardContainerLoadingError}
          >
            <View
              style={styles.shimmerContainer(theme)}
              testID={FrameworkTestKeys.dashboardDiscoverCardErrorView}
            >
              <DashboardErrorCard {...discoverLoadingError} />
            </View>
          </View>
        ) : (
          <View style={cardStyle} {...props} testID={FrameworkTestKeys.DiscoverCardContainer}>
            {ClonedDiscoverCard}
          </View>
        )}
      </VFTouchableInScroll>
    );
  }
}

DiscoverCard.defaultProps = {
  theme: LightThemeColors,
};

DiscoverCard.propTypes = {
  style: PropTypes.object,
  componentName: PropTypes.string.isRequired,
  type: PropTypes.any,
  showAddIcon: PropTypes.bool,
  loadingConfig: PropTypes.array,
  shimmerPlaceholderConfig: PropTypes.object,
  isLoading: PropTypes.bool,
  theme: PropTypes.object,
  children: PropTypes.object,
  onPressCard: PropTypes.func,
  discoverLoadingError: PropTypes.object,
};

export default withTheme(DiscoverCard);
